import {ComponentTypes} from '../constants/componentTypes.constants';

export function umsPopupIntraction(component: any) {
    if (!component) return;

    const {title = '', description = ''} = component.fields ?? {};

    return {
        title,
        description,
        componentType: ComponentTypes.UMS_POPUP_INTRACTION
    };
}
